import script from "./PolicySetup.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicySetup.vue?vue&type=script&setup=true&lang=js"

import "./PolicySetup.vue?vue&type=style&index=0&id=b1919e08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1919e08"]])

export default __exports__